import React from 'react';
import { Link } from 'react-router-dom';
import { PriceSimulator } from '../PriceSimulator';
import { Branch } from '../types/db';

interface ProgramPageProps {
  branches: Branch[];
  onRegisterClick: () => void;
}

export const ProgramPage: React.FC<ProgramPageProps> = ({ branches, onRegisterClick }) => {
  React.useEffect(() => {
    /* console removed */
  }, [branches]);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* HEADER */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10">
        <Link to="/" className="text-indigo-600 font-semibold hover:underline">
          ← Kembali ke Beranda
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-center mt-10">
          Program & Biaya Bimbingan
        </h1>

        <p className="text-center text-slate-500 mt-4 max-w-xl mx-auto">
          Pilih program belajar terbaik untuk membantu kamu masuk PTN favorit.
        </p>
      </div>

      {/* PROGRAM REGULER */}
      <Section title="Program Reguler">
        <Card
          title="SD"
          price="Rp 500.000"
          features={['4x pertemuan / minggu', 'Modul lengkap', 'Evaluasi bulanan']}
          onRegister={onRegisterClick}
        />

        <Card
          title="SMP"
          price="Rp 600.000"
          popular
          features={['4x pertemuan / minggu', 'Tryout rutin', 'Mentor terbaik']}
          onRegister={onRegisterClick}
        />

        <Card
          title="SMA"
          price="Rp 700.000"
          features={['Pendalaman materi', 'Simulasi UTBK', 'Bimbingan intensif']}
          onRegister={onRegisterClick}
        />
      </Section>

      {/* PROGRAM TKA */}
      <Section title="Program TKA">
        <Card
          title="TKA IPA"
          price="Rp 850.000"
          features={['Fokus mapel IPA', 'Latihan soal intens', 'Strategi ujian']}
          onRegister={onRegisterClick}
        />

        <Card
          title="TKA IPS"
          price="Rp 850.000"
          features={['Fokus mapel IPS', 'Bank soal lengkap', 'Pembahasan mendalam']}
          onRegister={onRegisterClick}
        />
      </Section>

      {/* PROGRAM UTBK */}
      <Section title="Program UTBK">
        <Card
          title="UTBK Intensive"
          price="Rp 1.200.000"
          popular
          features={['Tryout nasional', 'Analisis nilai', 'Strategi lolos PTN']}
          onRegister={onRegisterClick}
        />

        <Card
          title="UTBK Private"
          price="Rp 1.800.000"
          features={['Belajar 1 on 1', 'Fleksibel jadwal', 'Mentor spesialis']}
          onRegister={onRegisterClick}
        />
      </Section>

      {/* 🔥 SIMULATOR */}
      <PriceSimulator branches={branches} onRegisterClick={onRegisterClick} />

      {/* TRUST SECTION */}
      <div className="bg-white py-20 mt-20">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-black mb-10">Kenapa Pilih DELTA?</h2>

          <div className="grid md:grid-cols-3 gap-10">
            <Trust title="5000+ Alumni" desc="Ribuan siswa telah berhasil masuk PTN favorit." />

            <Trust title="Mentor Berpengalaman" desc="Pengajar dari kampus terbaik Indonesia." />

            <Trust title="Metode Terbukti" desc="Sistem belajar yang terstruktur dan efektif." />
          </div>
        </div>
      </div>

      {/* WHATSAPP FLOAT */}
      <a
        href="https://wa.me/6289671102061"
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white px-5 py-3 rounded-full shadow-xl font-semibold transition z-50 flex items-center gap-2"
      >
        Tanya Program 💬
      </a>
    </div>
  );
};

const Section = ({ title, children }: any) => (
  <div className="max-w-7xl mx-auto px-6 py-12">
    <h2 className="text-2xl font-black mb-8">{title}</h2>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">{children}</div>
  </div>
);

const Card = ({ title, price, features, popular, onRegister }: any) => (
  <div
    className={`bg-white border rounded-2xl p-8 transition hover:-translate-y-2 hover:shadow-2xl relative ${
      popular ? 'border-indigo-600 shadow-xl' : ''
    }`}
  >
    {popular && (
      <div className="absolute -top-3 left-6 bg-indigo-600 text-white text-xs px-3 py-1 rounded-full font-bold">
        Paling Populer
      </div>
    )}

    <h3 className="text-xl font-black mb-2">{title}</h3>

    <p className="text-slate-500 mb-6">Program belajar intensif</p>

    <ul className="space-y-2 text-sm text-slate-600 mb-6">
      {features.map((f: string, i: number) => (
        <li key={i}>✔ {f}</li>
      ))}
    </ul>

    <div className="text-3xl font-black text-indigo-600">
      {price}
      <span className="text-sm text-slate-500"> / bulan</span>
    </div>

    <button
      onClick={onRegister}
      className="mt-6 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-xl font-semibold transition"
    >
      Daftar Sekarang
    </button>
  </div>
);

const Trust = ({ title, desc }: any) => (
  <div className="p-6">
    <h3 className="font-black text-xl mb-3">{title}</h3>
    <p className="text-slate-500">{desc}</p>
  </div>
);
